module.exports = __webpack_public_path__ + "img/icon102.909bf689.png";